import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';

import { TClipOcr } from '../types';

export async function deleteClipOcr(id: string): Promise<TClipOcr[]> {
  return mediaManagerClient.delete(`/api/v1/clip_ocr/${id}`).then(({ data }) => data);
}

type MutationFn = typeof deleteClipOcr;

type TUseDeleteClipOcrParams = {
  config?: MutationConfig<MutationFn>;
};

export function useDeleteClipOcr({ config }: TUseDeleteClipOcrParams) {
  const { t } = useTranslation();
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    ...config,
    mutationFn: deleteClipOcr,
    onError(error) {
      addErrorNotification(t('No se ha podido eliminar el rótulo del corte'));
      console.error(error);
    },
    onSuccess() {
      addSuccessNotification(t('El rótulo del corte se ha eliminado correctamente'));
      queryClient.invalidateQueries({ queryKey: ['clip-logo'] });
    },
  });
}
